import React, {Component} from 'react';
import style from '../css/racer.css';
import ImageLoader from 'react-load-image';

// constants
import {ASSETS_URL} from '../../../../../../constants/endpoints';
//helpers
import {hasEventTypeRacerNumberUI} from '../../../../modules/racing/helpers/racersHelper';

class Racer extends Component {
    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let content;

        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        if (this.props.isSimpleRacer) {
            content = (<div className={style.simpleRacer}>
                <div id={'racer_name_' + this.props.racer.num} className={style.racerName}>
                    {this.props.racer.name}
                </div>
                <div className={style.simpleRacerBottomLine}>
                    <div id={'racer_silk_' + this.props.racer.num} className={style.racerIcon}>
                        {
                            hasEventTypeRacerNumberUI(selectedEvent.eventType)
                                ? (<div id={'racer_number_' + this.props.racer.num}
                                        className={style.racerNumber}>{this.props.racer.num}</div>)
                                : ''
                        }
                        <ImageLoader
                            src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(this.props.racer.silk) + 1}.png`}>
                            <img
                                src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(this.props.racer.silk) + 1}.png`}
                                className={style.racerIconImage} alt={`icon${this.props.racer.silk}`}/>
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.racerIconImage}
                                 alt={`loading`}/>
                        </ImageLoader>
                    </div>
                    <div id={'racer_' + this.props.racer.num + '_odd'} className={style.oddsText}>
                        {this.props.oddsText}
                    </div>
                </div>
            </div>);
        } else {
            content = (<div className={style.complexRacer}>
                <div id={'racer_name_' + this.props.racer.num} className={style.complexRacerName}>
                    <div className={style.complexRacerNameText}>
                        {this.props.racer.name}
                    </div>
                </div>
                <div id={'racer_silk_' + this.props.racer.num} className={style.racerIcon}>
                    {
                        hasEventTypeRacerNumberUI(selectedEvent.eventType)
                            ? (<div id={'racer_number_' + this.props.racer.num}
                                    className={style.racerNumber}>{this.props.racer.num}</div>)
                            : ''
                    }
                    <ImageLoader
                        src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(this.props.racer.silk) + 1}.png`}>
                        <img
                            src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(this.props.racer.silk) + 1}.png`}
                            className={style.complexRacerIconImage} alt={`icon${this.props.racer.silk}`}/>
                        <div>{''}</div>
                        <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.racerIconImage}
                             alt={`loading`}/>
                    </ImageLoader>
                </div>
            </div>);
        }
        return (<div className={`${style.racer} ${this.props.isSelected
            ? style.selected
            : ''}`}>
            {content}
        </div>);
    }
}

export default (Racer);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/racing/components/racer.js